export default __webpack_public_path__ + "static/media/avatar_nikki_dog8.612be8d7.mp3";